(() => {
  let intervalId = null;
  let deadline = null;

  function getEls() {
    const modal = document.querySelector('.nextdev--checkout-upsell-modal');
    if (!modal) return {};

    const countdown = modal.querySelector('.nextdev--checkout-upsell-modal--countdown-timer');
    const cancelBtn = modal.querySelector('button[name="cancel"]');
    const mm = countdown?.querySelector('.nextdev--checkout-upsell-modal--countdown-timer-minutes');
    const ss = countdown?.querySelector('.nextdev--checkout-upsell-modal--countdown-timer-seconds');
    const duration = mm.dataset.minutes;

    return { modal, countdown, cancelBtn, mm, ss, duration };
  }

  const pad2 = (n) => String(n).padStart(2, '0');

  function updateTimerDigit(el, newValue) {
    if (el && el.innerText !== newValue) {
      el.innerText = newValue;
      el.classList.remove('animate-change');

      void el.offsetWidth;
      el.classList.add('animate-change');
    }
  }

  function hideModal() {
    const { modal } = getEls();

    clearInterval(intervalId);
    intervalId = null;
    modal.classList.add('hide');
    document.body.classList.remove('overflow-hidden');

    window.location.href = '/checkout';
  }

  function tick() {
    const { mm, ss } = getEls();
    const now = Date.now();
    const timeLeft = Math.max(0, deadline - now);

    if (timeLeft === 0) {
      hideModal();
      return;
    }

    const mins = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const secs = Math.floor((timeLeft % (1000 * 60)) / 1000);

    if (mm) mm.innerText = pad2(mins);
    updateTimerDigit(ss, pad2(secs));
  }

  function start({ durationMs = 2 * 60 * 1000 } = {}) {
    const { countdown, swiper, modal } = getEls();
    if (!countdown) return;

    deadline = Date.now() + durationMs;
    if (intervalId) clearInterval(intervalId);

    tick();
    intervalId = setInterval(tick, 1000);

    document.body.classList.add('overflow-hidden');
    modal.classList.remove('hide');
  }

  function stop() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }

  window.CheckoutUpsellModalCountdown = { start, stop, isRunning: () => !!intervalId };

  const { cancelBtn } = getEls();

  cancelBtn.addEventListener('click', (e) => {
    e.preventDefault();

    hideModal();
  });
})();
